/**
 * Shared constants for WebSocket hub/services/events.
 */
export const HUB_NAMESPACE = 'c1-ws'

// NOTIFY domain
/**
 * Topic for leader → followers raw notify change payloads.
 * Payload type: ArrayBuffer (binary ChangedRef)
 */
export const TOPIC_NOTIFY_CHANGED_RAW = 'notify:changed-raw'

// CHAT domain
/**
 * Topic for leader → followers chat messages.
 * Payload type: ArrayBuffer (binary ChatMessage, for BroadcastChannel compatibility)
 */
export const TOPIC_CHAT_MESSAGE = 'chat:message'

/**
 * Topic for follower → leader to request joining a conversation.
 * Payload type: { conversationId: string; tabId: string }
 */
export const TOPIC_CHAT_JOIN = 'chat:join'

/**
 * Topic for follower → leader to request leaving a conversation.
 * Payload type: { conversationId: string; tabId: string }
 */
export const TOPIC_CHAT_LEAVE = 'chat:leave'

// SHARED
/**
 * Topic for leader → all tabs connection status updates.
 * Payload type: { status: 'connected' | 'reconnecting' | 'degraded' }
 */
export const TOPIC_LEADER_CONNECTION_STATUS = 'leader:connection-status'

/**
 * Topic for any tab → leader to force a reconnection attempt.
 * Payload type: {} (empty)
 */
export const TOPIC_FORCE_RECONNECT = 'leader:force-reconnect'

/**
 * Connection status values
 */
export type ConnectionStatus = 'connected' | 'reconnecting' | 'degraded' | 'failed'
